<script>
import moment from 'moment'

export default {
  props: {
    value: {
      // YYYY-MM-DD
      type: String,
      default: '',
    },
  },
  data() {
    return {
      year: 2024,
      quarter: 1,
      quarters: [1, 2, 3, 4],
    }
  },
  watch: {
    value: function (newVal) {
      this.initData(newVal)
    },
  },
  mounted() {
    this.initData(this.value)
  },
  methods: {
    initData(val) {
      this.year = val ? Number(val.split('-')[0]) : Number(moment().format('YYYY'))
      this.quarter = val
        ? Number(moment(val, 'YYYY-MM').format('Q'))
        : Number(moment().format('Q'))
    },
    select(val) {
      this.quarter = val
      const MAP = ['03', '06', '09', '12']
      this.$nextTick(() => {
        const val = `${this.year}-${MAP[this.quarter - 1]}`
        this.$emit('input', val)
        this.$emit('change', val)
      })
    },
  },
}
</script>

<template>
  <div class="bg-white" style="min-width: 200px; padding: 5px">
    <div class="d-flex justify-content-between align-items-center">
      <v-btn icon @click="year--">
        <v-icon> mdi-chevron-left </v-icon>
      </v-btn>
      <span class="text-bold">
        {{ year }}
      </span>
      <v-btn icon @click="year++">
        <v-icon> mdi-chevron-right </v-icon>
      </v-btn>
    </div>
    <div>
      <div
        v-for="q in quarters"
        :key="q"
        :class="{
          'bg-primary elevation-2': q === quarter && (value || '').includes(year),
        }"
        class="text-center mouse-hover rounded-lg"
        style="padding: 15px 0px; margin: 10px 30px 0px; border-radius: 12px"
        @click="select(q)"
      >
        <span>
          {{ q }}T
        </span>
      </div>
    </div>
  </div>
</template>
